import React from 'react';
import { Col, Table } from 'react-bootstrap';

// Components
import { authService } from '../../../_services/auth';

export class DiscordBot extends React.Component {
  constructor(props) {
    super(props);

    this.state = { logs: [] }
  }

  logLevelColor(level) {
    switch(level) {
      case 'warning':  return 'bg-warning';
      case 'error':  return 'bg-danger';
      default: return 'bg-info';
    }
  }

  logDateTime(timestamp) {
    return new Date(timestamp).toLocaleString();
  }

  componentDidMount() {
    this.pollInterval = setInterval(() => {
      authService.authenticatedRequest('/admin/dashboard/discord/log')
        .then(data => this.setState({ logs: data }))
        .catch(() => {});
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.pollInterval);
  }

  render() {
    return (
      <Col className="dashboard-column" md={12}>
        <h5>Discord Live Log</h5>
        <Table className="table-lite discord-log-table">
          <tbody>
            {this.state.logs.map(l => (
              <tr key={l.id} className={`small ${this.logLevelColor(l.level)}`}>
                <td className="discord-log-timestamp">{this.logDateTime(l.timestamp)}</td>
                <td className="discord-log-level">{l.level}</td>
                <td className="discord-log-module">{l.module}</td>
                <td className="discord-log-content">{l.content}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Col>
    )
  }
}